import React from 'react';
import { useParams, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { blogPosts } from '../data/blogPosts';
import '../styles/BlogPost.css';

const BlogPost = () => {
  const { id } = useParams();
  const post = blogPosts.find(post => post.id === parseInt(id));

  if (!post) {
    return (
      <div className="container">
        <div className="blog-content">
          <h1>Artikel nicht gefunden</h1>
          <p>Der gesuchte Artikel existiert leider nicht.</p>
          <Link to="/blog" className="back-link">Zurück zum Blog</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <article className="blog-post-full">
        <h1>{post.title}</h1>
        <div className="post-meta">
          <span className="post-date">
            {new Date(post.date).toLocaleDateString('de-DE')}
          </span>
          <span className="post-author">von {post.author}</span>
          {post.credentials && (
            <span className="post-credentials">({post.credentials})</span>
          )}
        </div>
        <div className="post-content">
          <ReactMarkdown>{post.content}</ReactMarkdown>
        </div>
        <Link to="/blog" className="back-link">← Zurück zum Blog</Link>
      </article>
    </div>
  );
};

export default BlogPost;